import { render, staticRenderFns } from "./Beam.vue?vue&type=template&id=67458b84&scoped=true&"
import script from "./Beam.vue?vue&type=script&lang=js&"
export * from "./Beam.vue?vue&type=script&lang=js&"
import style0 from "./Beam.vue?vue&type=style&index=0&id=67458b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67458b84",
  null
  
)

export default component.exports